import React from 'react';
import PropTypes from 'prop-types';
// @mui
import { useDispatch, useSelector } from 'react-redux';
import { styled, alpha } from '@mui/material/styles';
import {
  Toolbar,
  Tooltip,
  IconButton,
  Typography,
  OutlinedInput,
  InputAdornment,
  Popover,
  MenuItem,
  FormLabel,
  FormControl,
  Box,
  useTheme,
  InputLabel,
  Select,
  Chip,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  ListItemText,
} from '@mui/material';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { Icon } from '@iconify/react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { SearchEmployer } from '../../../redux/actions/Employeraction';
import Iconify from '../../../components/iconify';
// ----------------------------------------------------------------------

const StyledRoot = styled(Toolbar)(({ theme }) => ({
  height: 96,
  display: 'flex',
  justifyContent: 'space-between',
  padding: theme.spacing(0, 1, 0, 3),
}));

const StyledSearch = styled(OutlinedInput)(({ theme }) => ({
  width: 240,
  transition: theme.transitions.create(['box-shadow', 'width'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  '&.Mui-focused': {
    width: 320,
    boxShadow: theme.customShadows.z8,
  },
  '& fieldset': {
    borderWidth: `1px !important`,
    borderColor: `${alpha(theme.palette.grey[500], 0.32)} !important`,
  },
}));

// ----------------------------------------------------------------------

UserListToolbar.propTypes = {
  name: PropTypes.string,
  numSelected: PropTypes.number,
  filterName: PropTypes.string,
  onFilterName: PropTypes.func,
  handeltochange: PropTypes.any,
  handlestatusChange: PropTypes.any,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 300,
      overFlowY: 'auto',
    },
  },
};

function getStyles(name, personName, theme) {
  return {
    fontWeight:
      personName.indexOf(name) === -1 ? theme.typography.fontWeightRegular : theme.typography.fontWeightMedium,
  };
}

export default function UserListToolbar({
  name,
  numSelected,
  filterName,
  onFilterName,
  handeltochange,
  setFromdate,
  setTodate,
  handleselectChange,
  personName,
  handleFilter,
  handlestatusChange,
  sort,
  status,
  setSort,
  setPersonName,
}) {
  const theme = useTheme();

  const handleClick = () => {
    setSort(!sort);
  };

  const dispatch = useDispatch();

  const getEmployers = useSelector((state) => {
    return state?.Employer?.getEmployer?.data?.employers;
  });

  return (
    <StyledRoot
      sx={{
        ...(numSelected > 0 && {
          color: 'primary.main',
          bgcolor: 'primary.lighter',
        }),
      }}
    >
      {numSelected > 0 ? (
        <Typography component="div" variant="subtitle1">
          {numSelected} selected
        </Typography>
      ) : (
        <StyledSearch
          value={filterName}
          onChange={onFilterName}
          placeholder={`Search ${name}`}
          startAdornment={
            <InputAdornment position="start">
              <Iconify icon="eva:search-fill" sx={{ color: 'text.disabled', width: 20, height: 20 }} />
            </InputAdornment>
          }
        />
      )}

      {numSelected > 0 ? (
        <Tooltip title="Delete">
          <IconButton>
            <Iconify icon="eva:trash-2-fill" />
          </IconButton>
        </Tooltip>
      ) : (
        <IconButton sx={{ position: 'relative' }} onClick={handleClick}>
          <Iconify icon="ic:round-filter-list" />
        </IconButton>
      )}

      {sort && (
        <Box
          sx={{
            position: 'absolute',
            width: '300px',
            top: '70px',
            right: '0',
            zIndex: '999',
            bgcolor: 'white',
          }}
        >
          <MenuItem sx={{ display: 'flex', alignItems: 'center', color: 'error.main', gap: '10px' }}>
            <FormLabel>From :</FormLabel>
            <FormControl size="small">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker
                    onChange={(e) => setFromdate(e)}
                    slotProps={{ textField: { size: 'small' } }}
                    // label=""
                  />
                </DemoContainer>
              </LocalizationProvider>
            </FormControl>
          </MenuItem>
          <MenuItem sx={{ display: 'flex', alignItems: 'center', color: 'error.main', gap: '10px' }}>
            <FormLabel>To :</FormLabel>
            <FormControl size="small">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={['DatePicker']}>
                  <DatePicker onChange={(e) => setTodate(e)} slotProps={{ textField: { size: 'small' } }} label="" />
                </DemoContainer>
              </LocalizationProvider>
            </FormControl>
          </MenuItem>

          {name === 'User' && (
            <>
              <Box sx={{ minWidth: 120, margin: '10px' }}>
                <FormControl size="small" fullWidth>
                  <InputLabel id="demo-simple-select-label">status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={status}
                    label="Status"
                    size="small"
                    onChange={handlestatusChange}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="success">Verified</MenuItem>
                    <MenuItem
                      value="failure
                    "
                    >
                      Pending
                    </MenuItem>
                    <MenuItem value="inprogress">In Progress</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </>
          )}

          {name !== 'Employer' && name !== 'Tickets' && name !== 'Transaction' && (
            <>
              <div>
                <FormControl size="small" sx={{ m: 1, width: 270 }}>
                  <InputLabel id="demo-multiple-checkbox-label">Employer</InputLabel>

                  <Select
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    value={personName}
                    onChange={handleselectChange}
                    input={<OutlinedInput label="Tag" />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                  >
                    {getEmployers?.map((name) => (
                      <MenuItem key={name} value={name?.EmployerName}>
                        <Checkbox checked={personName.indexOf(name?.EmployerName) > -1} />
                        <ListItemText primary={name?.EmployerName} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </>
          )}

          {name === 'Tickets' && (
            <>
              <Box sx={{ minWidth: 120, margin: '10px' }}>
                <FormControl size="small" fullWidth>
                  <InputLabel id="demo-simple-select-label">status</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={status}
                    label="Status"
                    onChange={handlestatusChange}
                  >
                    <MenuItem value="">All</MenuItem>
                    <MenuItem value="open">Open</MenuItem>
                    <MenuItem value="closed">Close</MenuItem>
                    <MenuItem value="inprogress">In Progress</MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </>
          )}

          <Button onClick={handleFilter} sx={{ margin: '10px', alignItems: 'end' }} variant="contained">
            Filter
          </Button>
        </Box>
      )}

      {/* <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'Right',
        }}
        sx={{
          width: '400px',
        }}
      >
        <Box></Box>
      </Popover> */}
    </StyledRoot>
  );
}
